<template>
  <keep-alive>
    <div class="d-flex align-center">
      <component
        :is="component"
        :value="value"
        :label="label"
        :disabled="disabled || disableInputSelection"
        :path="path"
        :item-text="itemText"
        :sort-by="sortBy"
        :item-value="itemValue"
        :api-get-response-item-text="apiGetResponseItemText"
        :mandatory-filters="mandatoryFilters"
        :get-data="responseData"
        :rules="rules"
        :vid="vid"
        :return-object="returnObject"
        :readonly="readonly"
        :clearable="clearable"
        :multiple="multiple"
        :chips="chips"
        :deletable-chips="deletableChips"
        :cache-items="cacheItems"
        @input="$emit('input', $event)"
      />
      <div class="pt-1">
        <w-search-button
          v-if="!readonly"
          :color="errors.length > 0 ? 'error' : 'primary'"
          :disabled="disabled"
          @click.stop="$emit('click:openDialog')"
        >
          <template #tooltip>
            <slot name="tooltip">
              {{ $t('Components.sentences.chooseContact') }}
            </slot>
          </template>
        </w-search-button>
      </div>
    </div>
  </keep-alive>
</template>

<script>
// components
import contactPickerProps from '@/components/global_components/pickers/contact_picker/mixins/contact-picker-props';

export default {
  name: 'WorkContactPickerWithInputField',
  mixins: [contactPickerProps],
  computed: {
    component() {
      if (this.isFormElement) {
        return 'w-form-autocomplete-lazy';
      }
      return 'w-autocomplete-lazy';
    }
  }
};
</script>
